module.exports = __webpack_public_path__ + "static/media/testomonialimg1.b7ce153c.png";